import React from 'react'
import { FormattedMessage } from 'react-intl'

import styled, { useTheme } from 'styled-components/native'

import { BodyText } from '../../atoms/bodyText/BodyText'
import { BodyTextSize } from '../../styles/typeStyles'
import { tID } from '../../utils'

export interface PatientHasGuardianBannerProps {
  patientName: string
  guardianName: string
}

const BannerContainer = styled.View<{ backgroundColor?: string }>(({ backgroundColor }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: backgroundColor,
  padding: '12px',
}))

export const PatientHasGuardianBanner: React.FC<PatientHasGuardianBannerProps> = ({ patientName, guardianName }) => {
  const { colors } = useTheme()

  return (
    <BannerContainer
      backgroundColor={colors.components?.inlineInfoBanner?.background}
      testID={tID('PatientHasGuardianBanner')}
    >
      <BodyText
        size={BodyTextSize.SMALL}
        color={colors.components?.inlineInfoBanner?.text}
        textAlign='center'
        text={
          guardianName ? (
            <FormattedMessage
              defaultMessage={`You're messaging {patientName}'s caregiver, {guardianName}`}
              description='Banner text for when a patient has a guardian with name'
              values={{ patientName, guardianName }}
            />
          ) : (
            <FormattedMessage
              defaultMessage={`You're messaging {patientName}'s caregiver`}
              description='Banner text for when a patient has a guardian without name'
              values={{ patientName }}
            />
          )
        }
      />
    </BannerContainer>
  )
}
